import type {
  IngestTestRequest,
  IngestTestResponse,
} from '@billing/validation/ingestTest';
import { ingestTestResponseSchema } from '@billing/validation/ingestTest';
import { postRequest } from 'api/utils/HttpMethods';

export const submitIngestTest = async (
  request: IngestTestRequest
): Promise<IngestTestResponse> => {
  const response = await postRequest<IngestTestResponse, IngestTestRequest>(
    'QBilling',
    '/action/ingest/test',
    request
  );
  if (!response) {
    throw new Error('Ingest test returned no response.');
  }
  return ingestTestResponseSchema.parse(response);
};
